<ngb-datepicker
  #dp
  (select)="onDateSelection($event)"
  [displayMonths]="2"
  [dayTemplate]="tmplDate"
  [startDate]="fromDate"
  outsideDays="hidden">
</ngb-datepicker>

<ng-template #tmplDate let-date="date" let-focused="focused">
  <span *ngIf="date" class="drp-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null">
    {{ date.day }}
  </span>
</ng-template>
